import { useEffect, useState } from "react";
import "./styles.css";
import { FaceScan } from "./FaceScan";
import { TopHeadValidate } from "./TopHeadValidate";
import { CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import useScanImages from "../../hooks/useScanImages";
import { AddImageUrl } from "../../constants";
import { HeadInitialize } from "./HeadInitialize";
import { HeadScan } from "./HeadScan";
import { useConfig } from "../../context/ConfigContext";

export const ScanModule = ({
  apiToken,
  faceModel,
  runNextModule = () => {},
  onError = () => {},
}) => {
  const { t } = useTranslation("scanModule");
  const { imagesCaptured, addImage, uploadImages, validateTopHeadImage } =
    useScanImages();
  const { configData } = useConfig();

  const [currentStep, updateCurrentStep] = useState(0);
  const [showHeadTutorial, setShowHeadTutorial] = useState(true);

  useEffect(() => {
    if (currentStep === 4 && imagesCaptured) {
      // Cloud API
      const timerId = setTimeout(() => {
        uploadImages(AddImageUrl, apiToken).then((response) => {
          if (response) {
            runNextModule();
          } else {
            onError();
          }
        });
      }, 1000);

      return () => clearTimeout(timerId);
    }
  });

  const loadNextStep = () => {
    updateCurrentStep((prevState) => {
      if (prevState === 0 && !configData.HeadModuleFlags.isEnabled) {
        return 4;
      } else {
        return prevState + 1;
      }
    });
  };

  const renderCurrentStep = () => {
    switch (currentStep) {
      case 1:
        return (
          <HeadInitialize
            onSkipClick={() => updateCurrentStep(4)}
            onContinueClick={loadNextStep}
          />
        );
      case 2:
        return (
          <HeadScan
            onBack={showHeadTutorial ? () => updateCurrentStep(1) : undefined}
            onFinish={loadNextStep}
            addImage={addImage}
          />
        );
      case 3:
        return (
          <TopHeadValidate
            onBack={() => {
              setShowHeadTutorial(false);
              updateCurrentStep(2);
            }}
            onContinue={loadNextStep}
            onError={onError}
            validateTopHeadImage={validateTopHeadImage}
          />
        );
      case 4:
        return (
          <div className="scan-module-loading">
            <CircularProgress
              disableShrink
              color="inherit"
              size={40}
              thickness={4}
            />
            <p className="scan-interim-text">
              {configData.FaceModuleFlags.sideScanEnabled
                ? t("upload-images")
                : t("upload-image")}
            </p>
          </div>
        );
      default:
        return (
          <FaceScan
            sideFaceEnabled={configData.FaceModuleFlags.sideScanEnabled}
            addImage={addImage}
            runFaceModel={faceModel}
            onComplete={loadNextStep}
            onError={onError}
          />
        );
    }
  };

  return <div className="scan-module">{renderCurrentStep()}</div>;
};
